(function () {
  'use strict';

  var assetFlag = '__swymWishlistPageAssetLoaded';
  var controllers = new WeakMap();
  var productCachePrefix = 'swymWishlistProduct:v1:';
  var productCacheTtl = 60 * 60 * 1000;
  var productRequests = new Map();
  var swatInstance = null;
  var wholesaleCardTimeout = 5000;
  var wholesalePollInterval = 100;
  var wholesaleReadyTimeout = 10000;

  if (window[assetFlag]) {
    return;
  }
  window[assetFlag] = true;

  function normalizeId(value) {
    return value === null || typeof value === 'undefined' ? '' : String(value);
  }

  function getProductKey(product) {
    return normalizeId(product && product.empi) + ':' + normalizeId(product && product.epi);
  }

  function copySwymProduct(product) {
    return {
      empi: product.empi,
      epi: product.epi,
      du: product.du,
      dt: product.dt,
      iu: product.iu,
      pr: product.pr
    };
  }

  function createElement(tagName, className, textContent) {
    var element = document.createElement(tagName);

    if (className) {
      element.className = className;
    }
    if (typeof textContent !== 'undefined') {
      element.textContent = textContent;
    }

    return element;
  }

  function replaceToken(template, token, value) {
    return String(template || '').split(token).join(String(value));
  }

  function getWholesaleJQuery() {
    var jquery = null;

    try {
      if (typeof window.WSAIO_GET_JQUERY === 'function') {
        jquery = window.WSAIO_GET_JQUERY();
      }
    } catch (error) {
      jquery = null;
    }

    if (typeof jquery !== 'function' && typeof window.jQuery === 'function') {
      jquery = window.jQuery;
    }

    return typeof jquery === 'function' ? jquery : null;
  }

  function getWholesaleBridge() {
    var app = window.WSAIO;
    var jquery = getWholesaleJQuery();

    if (
      !app ||
      !jquery ||
      typeof app.isWholesaleCustomer !== 'function' ||
      typeof app.productDiscount !== 'function' ||
      !app.general_settings ||
      typeof app.general_settings.discount_method === 'undefined'
    ) {
      return null;
    }

    return {
      app: app,
      jquery: jquery
    };
  }

  function parseConfig(root) {
    var configElement = root.querySelector('[data-swym-wishlist-config]');

    if (!configElement) {
      throw new Error('Wishlist configuration is missing.');
    }

    return JSON.parse(configElement.textContent);
  }

  function getHandle(product, swymProduct) {
    if (product && product.handle) {
      return product.handle;
    }

    try {
      var url = new URL(swymProduct.du, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]).replace(/\.js$/, '') : '';
    } catch (error) {
      return '';
    }
  }

  function getLocalizedProductPath(config, handle) {
    var root = config.routes.root || '/';
    return root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  }

  function getProductUrl(config, swymProduct, product) {
    var handle = getHandle(product, swymProduct);
    var path;

    if (handle) {
      path = getLocalizedProductPath(config, handle);
    } else {
      try {
        var swymUrl = new URL(swymProduct.du, window.location.origin);
        path = swymUrl.pathname;
      } catch (error) {
        path = config.routes.root || '/';
      }
    }

    if (swymProduct.epi) {
      path += (path.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(swymProduct.epi);
    }

    return path;
  }

  function getProductJsonUrl(config, swymProduct) {
    var handle = getHandle(null, swymProduct);

    if (handle) {
      return getLocalizedProductPath(config, handle) + '?view=wishlist-json';
    }

    var fallbackUrl = new URL(swymProduct.du, window.location.origin);
    fallbackUrl.hash = '';
    fallbackUrl.search = '';
    fallbackUrl.pathname = fallbackUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '');
    fallbackUrl.searchParams.set('view', 'wishlist-json');
    return fallbackUrl.pathname + fallbackUrl.search;
  }

  function getProductCacheKey(productUrl) {
    var shopify = window.Shopify || {};
    var currency = shopify.currency && shopify.currency.active ? shopify.currency.active : '';
    var market = shopify.country || '';
    var locale = shopify.locale || document.documentElement.lang || '';
    var context = [productUrl, currency, market, locale].map(function (value) {
      return encodeURIComponent(String(value));
    }).join(':');

    return productCachePrefix + context;
  }

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function isValidProductData(product) {
    return Boolean(
      product &&
      typeof product === 'object' &&
      !Array.isArray(product) &&
      normalizeId(product.id) &&
      typeof product.handle === 'string' &&
      Array.isArray(product.variants)
    );
  }

  function removeCachedProduct(storage, cacheKey) {
    try {
      storage.removeItem(cacheKey);
    } catch (error) {
      // Storage is a progressive enhancement; product requests can continue without it.
    }
  }

  function readCachedProduct(productUrl) {
    var storage = getSessionStorage();
    var cacheKey;
    var cached;

    if (!storage) {
      return null;
    }

    cacheKey = getProductCacheKey(productUrl);

    try {
      cached = JSON.parse(storage.getItem(cacheKey));
    } catch (error) {
      removeCachedProduct(storage, cacheKey);
      return null;
    }

    if (
      !cached ||
      !Number.isFinite(Number(cached.expiresAt)) ||
      Number(cached.expiresAt) <= Date.now() ||
      !isValidProductData(cached.product)
    ) {
      removeCachedProduct(storage, cacheKey);
      return null;
    }

    return cached.product;
  }

  function writeCachedProduct(productUrl, product) {
    var storage = getSessionStorage();

    if (!storage || !isValidProductData(product)) {
      return;
    }

    try {
      storage.setItem(getProductCacheKey(productUrl), JSON.stringify({
        expiresAt: Date.now() + productCacheTtl,
        product: product
      }));
    } catch (error) {
      // Quota and privacy-mode failures should not block wishlist rendering.
    }
  }

  function fetchProduct(config, swymProduct) {
    var productUrl = getProductJsonUrl(config, swymProduct);
    var cachedProduct;

    if (productRequests.has(productUrl)) {
      return productRequests.get(productUrl);
    }

    cachedProduct = readCachedProduct(productUrl);
    if (cachedProduct) {
      return Promise.resolve(cachedProduct);
    }

    var request = window.fetch(productUrl, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Product request failed with status ' + response.status + '.');
      }

      return response.json();
    }).then(function (product) {
      if (!isValidProductData(product)) {
        throw new Error('Product response is invalid.');
      }

      writeCachedProduct(productUrl, product);
      return product;
    });

    productRequests.set(productUrl, request);
    request.then(function () {
      productRequests.delete(productUrl);
    }, function () {
      productRequests.delete(productUrl);
    });
    return request;
  }

  function enrichProduct(config, swymProduct) {
    if (!swymProduct.du) {
      return Promise.resolve({
        product: null,
        swym: swymProduct,
        variant: null
      });
    }

    return Promise.resolve().then(function () {
      return fetchProduct(config, swymProduct);
    }).then(function (product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.find(function (candidate) {
        return normalizeId(candidate.id) === normalizeId(swymProduct.epi);
      }) || null;

      return {
        product: product,
        swym: swymProduct,
        variant: variant
      };
    }).catch(function (error) {
      console.warn('Swym wishlist: Unable to refresh product data for ' + getProductKey(swymProduct) + '.', error);
      return {
        product: null,
        swym: swymProduct,
        variant: null
      };
    });
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = Number(number);

    if (!Number.isFinite(value)) {
      return '0';
    }

    var parts = value.toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents, moneyFormat) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, moneyFormat);
    }

    var format = moneyFormat || '${{ amount }}';
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var amount = Number(cents) / 100;
    var formatted;

    if (!placeholder) {
      return formatWithDelimiters(amount, 2, ',', '.');
    }

    switch (placeholder[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(amount, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatWithDelimiters(amount, 0, ' ', '.');
        break;
      default:
        formatted = formatWithDelimiters(amount, 2, ',', '.');
    }

    return format.replace(placeholder[0], formatted);
  }

  function getImageData(product, variant, swymProduct) {
    var variantImage = variant && variant.featured_image;
    var source = variantImage && variantImage.src;

    if (!source && product) {
      source = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image && product.featured_image.src;
    }
    if (!source && product && Array.isArray(product.images)) {
      source = typeof product.images[0] === 'string' ? product.images[0] : product.images[0] && product.images[0].src;
    }
    if (!source) {
      source = swymProduct.iu;
    }

    return {
      alt: variantImage && variantImage.alt,
      aspectRatio: Number(variantImage && variantImage.aspect_ratio) || 1,
      height: Number(variantImage && variantImage.height) || 0,
      source: source || '',
      width: Number(variantImage && variantImage.width) || 0
    };
  }

  function getCardData(config, enrichedProduct) {
    var product = enrichedProduct.product;
    var swymProduct = enrichedProduct.swym;
    var variant = enrichedProduct.variant;
    var price = variant ? Number(variant.price) : Math.round(Number(swymProduct.pr) * 100);
    var compareAtPrice = variant ? Number(variant.compare_at_price) : 0;
    var title = product && product.title ? product.title : swymProduct.dt || '';
    var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var isCiem = Boolean(variant && product && Number(product.ciem_flag) === 1);

    return {
      available: Boolean(variant && variant.available),
      compareAtPrice: Number.isFinite(compareAtPrice) ? compareAtPrice : 0,
      image: getImageData(product, variant, swymProduct),
      isCiem: isCiem,
      key: getProductKey(swymProduct),
      price: Number.isFinite(price) ? price : null,
      product: product,
      resolved: Boolean(variant),
      swym: swymProduct,
      title: title,
      url: getProductUrl(config, swymProduct, product),
      variant: variant,
      variantTitle: variantTitle,
      vendor: product && product.vendor ? product.vendor : ''
    };
  }

  function createCloseIcon() {
    var svgNamespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNamespace, 'svg');
    var path = document.createElementNS(svgNamespace, 'path');

    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('role', 'presentation');
    svg.setAttribute('class', 'icon icon-close');
    svg.setAttribute('viewBox', '0 0 64 64');
    path.setAttribute('d', 'M19 17.61l27.12 27.13m0-27.12L19 44.74');
    svg.appendChild(path);
    return svg;
  }

  class SwymWishlistPage {
    constructor(root, swat) {
      this.root = root;
      this.swat = swat;
      this.config = parseConfig(root);
      this.count = root.querySelector('[data-swym-wishlist-count]');
      this.empty = root.querySelector('[data-swym-wishlist-empty]');
      this.error = root.querySelector('[data-swym-wishlist-error]');
      this.grid = root.querySelector('[data-swym-wishlist-grid]');
      this.loading = root.querySelector('[data-swym-wishlist-loading]');
      this.products = root.querySelector('[data-swym-wishlist-products]');
      this.retry = root.querySelector('[data-swym-wishlist-retry]');
      this.status = root.querySelector('[data-swym-wishlist-status]');
      this.cartEventCleanups = new Map();
      this.items = new Map();
      this.loadToken = 0;
      this.pendingRemovals = new Map();
      this.wholesaleGeneration = 0;
      this.wholesaleWaitResolve = null;
      this.wholesaleWaitTimer = null;
      this.handleClick = this.handleClick.bind(this);
      this.handleRetry = this.loadWishlist.bind(this);

      this.root.addEventListener('click', this.handleClick);
      if (this.retry) {
        this.retry.addEventListener('click', this.handleRetry);
      }

      this.loadWishlist();
    }

    destroy() {
      this.loadToken += 1;
      this.invalidateWholesalePricing();
      this.pendingRemovals.clear();
      this.root.removeEventListener('click', this.handleClick);
      if (this.retry) {
        this.retry.removeEventListener('click', this.handleRetry);
      }
      this.clearCartEventListeners();
    }

    loadWishlist() {
      var requestToken = ++this.loadToken;

      this.showState('loading');
      this.clearGrid();

      try {
        this.swat.fetch(
          function (products) {
            if (requestToken !== this.loadToken) {
              return;
            }

            var seen = new Set();
            var wishlistProducts = (Array.isArray(products) ? products : []).filter(function (product) {
              var key = getProductKey(product);
              var isValid = normalizeId(product && product.empi) && normalizeId(product && product.epi);

              if (!isValid || seen.has(key)) {
                return false;
              }

              seen.add(key);
              return true;
            }).map(copySwymProduct);

            if (!wishlistProducts.length) {
              this.showState('empty');
              return;
            }

            Promise.all(wishlistProducts.map(function (product) {
              setTimeout(() => {}, 300);
              return enrichProduct(this.config, product);
            }, this)).then(function (enrichedProducts) {
              if (requestToken !== this.loadToken) {
                return;
              }
              this.renderProducts(enrichedProducts);
            }.bind(this));
          }.bind(this),
          function (error) {
            if (requestToken !== this.loadToken) {
              return;
            }
            console.error('Swym wishlist: Unable to fetch the default wishlist.', error);
            this.showState('error');
          }.bind(this)
        );
      } catch (error) {
        console.error('Swym wishlist: Unable to fetch the default wishlist.', error);
        this.showState('error');
      }
    }

    showState(state) {
      this.root.setAttribute('aria-busy', String(state === 'loading'));
      this.loading.hidden = state !== 'loading';
      this.error.hidden = state !== 'error';
      this.empty.hidden = state !== 'empty';
      this.products.hidden = state !== 'products';
      this.count.hidden = state !== 'products';
    }

    clearGrid() {
      this.invalidateWholesalePricing();
      this.clearCartEventListeners();
      this.items.clear();
      this.pendingRemovals.clear();

      while (this.grid.firstChild) {
        this.grid.removeChild(this.grid.firstChild);
      }
    }

    renderProducts(enrichedProducts) {
      this.clearGrid();

      enrichedProducts.forEach(function (enrichedProduct, index) {
        var cardData = getCardData(this.config, enrichedProduct);
        this.items.set(cardData.key, cardData);
        this.grid.appendChild(this.createCard(cardData, index));
      }, this);

      if (!this.items.size) {
        this.showState('empty');
        return;
      }

      this.updateCount();
      this.showState('products');
      this.applyWholesalePricing(this.wholesaleGeneration);
    }

    createCard(cardData, index) {
      var settings = this.config.settings;
      var strings = this.config.strings;
      var gridItem = createElement('div', 'grid__item grid-product small--one-half medium-up--one-third');
      var content = createElement('div', 'grid-product__content grid-product--' + settings.gridStyle + ' swym-wishlist-card');
      var card = createElement('div', 'grid-product__link swym-wishlist-card__link');
      var imageLink = createElement('a', 'grid-product__image');
      var imageMask = createElement('div', 'grid-product__image-mask');
      var imageRatio = createElement('div', 'grid__image-ratio');
      var metadata = createElement('a', 'grid-product__meta swym-wishlist-card__meta');
      var removeButton = createElement('button', 'swym-wishlist-card__remove');
      var isOnSale = cardData.available && cardData.compareAtPrice > cardData.price;

      gridItem.dataset.productText = settings.textAlign;
      card.dataset.swymWishlistCard = cardData.key;
      imageLink.href = cardData.url;
      metadata.href = cardData.url;

      if (!cardData.available && !cardData.isCiem) {
        imageLink.appendChild(createElement(
          'div',
          'grid-product__tag grid-product__tag--sold-out',
          cardData.resolved ? strings.soldOut : strings.unavailable
        ));
      } else if (isOnSale) {
        imageLink.appendChild(createElement('div', 'grid-product__tag grid-product__tag--sale', strings.sale));
      }

      if (settings.imageSize === 'natural') {
        imageRatio.classList.add('swym-wishlist-card__image--natural');
        imageRatio.style.setProperty('--swym-image-ratio', (100 / cardData.image.aspectRatio) + '%');
      } else {
        imageRatio.classList.add('grid__image-ratio--' + settings.imageSize);
      }

      if (cardData.image.source) {
        var image = createElement('img', 'lazyloaded');
        image.src = cardData.image.source;
        image.alt = cardData.image.alt || cardData.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = '(min-width: 769px) 33vw, 50vw';
        if (!settings.imageFill) {
          image.classList.add('grid__image-contain');
        }
        if (cardData.image.width) {
          image.width = cardData.image.width;
        }
        if (cardData.image.height) {
          image.height = cardData.image.height;
        }
        imageRatio.appendChild(image);
      } else {
        imageRatio.appendChild(createElement('span', 'swym-wishlist-card__image-placeholder', cardData.title.slice(0, 1)));
      }

      imageMask.appendChild(imageRatio);
      imageLink.appendChild(imageMask);
      card.appendChild(imageLink);

      if (settings.showVendor && cardData.vendor) {
        metadata.appendChild(createElement('div', 'grid-product__vendor', cardData.vendor));
      }

      metadata.appendChild(createElement(
        'div',
        'grid-product__title grid-product__title--' + settings.titleStyle,
        cardData.title
      ));

      if (cardData.variantTitle) {
        metadata.appendChild(createElement('div', 'swym-wishlist-card__variant', cardData.variantTitle));
      }

      if (cardData.price !== null) {
        metadata.appendChild(this.createPrice(cardData, isOnSale));
      }

      card.appendChild(metadata);

      removeButton.type = 'button';
      removeButton.dataset.swymWishlistRemove = cardData.key;
      removeButton.dataset.disabled = 'false';
      removeButton.setAttribute('aria-label', replaceToken(strings.remove, '[title]', cardData.title));
      removeButton.appendChild(createCloseIcon());
      card.appendChild(removeButton);
      cardData.card = card;

      var cta = cardData.isCiem
        ? this.createProductDetailsCta(cardData)
        : this.createCartForm(cardData);
      card.appendChild(cta);
      content.appendChild(card);
      gridItem.appendChild(content);

      if (!cardData.isCiem && settings.cartType === 'drawer' && cardData.available) {
        this.initializeAjaxCart(cta, card, cardData, index);
      } else if (!cardData.isCiem && cardData.available) {
        this.initializePageCart(cta, card, cardData);
      }

      return gridItem;
    }

    createPrice(cardData, isOnSale) {
      var price = createElement('div', 'grid-product__price');

      price.dataset.swymWishlistPrice = '';

      if (isOnSale) {
        price.appendChild(createElement('span', 'visually-hidden', this.config.strings.regularPrice));
        price.appendChild(createElement(
          'span',
          'grid-product__price--original',
          formatMoney(cardData.compareAtPrice, this.config.settings.moneyFormat)
        ));
        price.appendChild(createElement('span', 'visually-hidden', this.config.strings.salePrice));
      }

      price.appendChild(createElement(
        'span',
        isOnSale ? 'grid-product__price--save' : 'grid-product__price--regurar',
        formatMoney(cardData.price, this.config.settings.moneyFormat)
      ));
      price.appendChild(createElement('div', 'product__price-tax', this.config.strings.includeTaxes));
      return price;
    }

    cancelWholesaleWait() {
      var resolve = this.wholesaleWaitResolve;

      if (this.wholesaleWaitTimer) {
        window.clearTimeout(this.wholesaleWaitTimer);
        this.wholesaleWaitTimer = null;
      }
      this.wholesaleWaitResolve = null;

      if (resolve) {
        resolve(null);
      }
    }

    invalidateWholesalePricing() {
      this.wholesaleGeneration += 1;
      this.cancelWholesaleWait();
    }

    isWholesaleRenderCurrent(generation) {
      return generation === this.wholesaleGeneration && this.root.isConnected;
    }

    waitForWholesaleApp(generation) {
      var deadline = Date.now() + wholesaleReadyTimeout;

      this.cancelWholesaleWait();

      return new Promise(function (resolve) {
        var finish = function (bridge) {
          if (this.wholesaleWaitResolve !== resolve) {
            return;
          }

          if (this.wholesaleWaitTimer) {
            window.clearTimeout(this.wholesaleWaitTimer);
            this.wholesaleWaitTimer = null;
          }
          this.wholesaleWaitResolve = null;
          resolve(bridge);
        }.bind(this);
        var check = function () {
          var bridge;

          if (!this.isWholesaleRenderCurrent(generation) || window.WSAIO_is_disabled === true) {
            finish(null);
            return;
          }

          bridge = getWholesaleBridge();
          if (bridge) {
            finish(bridge);
            return;
          }

          if (Date.now() >= deadline) {
            if (window.WSAIO) {
              console.warn('Swym wishlist: WSAIO was not ready before wholesale pricing timed out.');
            }
            finish(null);
            return;
          }

          this.wholesaleWaitTimer = window.setTimeout(check, wholesalePollInterval);
        }.bind(this);

        this.wholesaleWaitResolve = resolve;
        check();
      }.bind(this));
    }

    applyWholesalePricing(generation) {
      var cards = Array.from(this.items.values()).filter(function (cardData) {
        return cardData.resolved && cardData.product && cardData.variant && cardData.price !== null;
      });

      if (!cards.length) {
        return;
      }

      this.waitForWholesaleApp(generation).then(function (bridge) {
        var isWholesaleCustomer;

        if (!bridge || !this.isWholesaleRenderCurrent(generation)) {
          return;
        }

        try {
          isWholesaleCustomer = bridge.app.isWholesaleCustomer();
        } catch (error) {
          console.error('Swym wishlist: Unable to check wholesale customer eligibility.', error);
          return;
        }

        if (!isWholesaleCustomer) {
          return;
        }

        return this.applyWholesalePricingQueue(cards, 0, bridge, generation);
      }.bind(this)).catch(function (error) {
        console.error('Swym wishlist: Unable to apply wholesale pricing.', error);
      });
    }

    applyWholesalePricingQueue(cards, index, bridge, generation) {
      if (!this.isWholesaleRenderCurrent(generation) || index >= cards.length) {
        return Promise.resolve();
      }

      // WSAIO stores the selected product and variant globally, so these calls must remain serial.
      return this.applyWholesalePrice(cards[index], bridge, generation).then(function (continueQueue) {
        if (!continueQueue) {
          return;
        }

        return this.applyWholesalePricingQueue(cards, index + 1, bridge, generation);
      }.bind(this));
    }

    isWholesaleCardCurrent(cardData, generation) {
      return (
        this.isWholesaleRenderCurrent(generation) &&
        this.items.get(cardData.key) === cardData &&
        cardData.card &&
        cardData.card.isConnected
      );
    }

    applyWholesalePrice(cardData, bridge, generation) {
      var price = cardData.card && cardData.card.querySelector('[data-swym-wishlist-price]');

      if (!price || !this.isWholesaleCardCurrent(cardData, generation)) {
        return Promise.resolve(true);
      }

      var taxNotice = price.querySelector('.product__price-tax');
      var originalPrice = {
        className: price.className,
        html: price.innerHTML,
        style: price.style.cssText
      };

      return new Promise(function (resolve) {
        var callbackCalled = false;
        var callbackResponse;
        var callReturned = false;
        var settled = false;
        var timeoutId;
        var restorePrice = function () {
          if (!this.isWholesaleCardCurrent(cardData, generation)) {
            return;
          }

          price.className = originalPrice.className;
          price.innerHTML = originalPrice.html;
          price.style.cssText = originalPrice.style;
        }.bind(this);
        var preserveTaxNotice = function () {
          if (
            taxNotice &&
            this.isWholesaleCardCurrent(cardData, generation) &&
            !price.querySelector('.product__price-tax')
          ) {
            price.appendChild(taxNotice);
          }
        }.bind(this);
        var finish = function (continueQueue, shouldRestore, error) {
          if (settled) {
            return;
          }

          settled = true;
          window.clearTimeout(timeoutId);
          if (shouldRestore) {
            restorePrice();
          }
          if (error) {
            console.error('Swym wishlist: Unable to apply wholesale pricing for ' + cardData.key + '.', error);
          }
          resolve(continueQueue);
        };
        var handleResponse = function (response) {
          if (settled) {
            restorePrice();
            return;
          }

          if (!this.isWholesaleRenderCurrent(generation)) {
            finish(false, false);
            return;
          }
          if (!this.isWholesaleCardCurrent(cardData, generation)) {
            finish(true, false);
            return;
          }
          if (response && response.error) {
            finish(false, true, response.error === 'Invalid customer' ? null : response.error);
            return;
          }

          preserveTaxNotice();
          finish(true, false);
        }.bind(this);
        var callback = function (response) {
          callbackCalled = true;
          callbackResponse = response;

          if (callReturned) {
            handleResponse(response);
          }
        };

        timeoutId = window.setTimeout(function () {
          finish(false, true, new Error('WSAIO product discount callback timed out.'));
        }, wholesaleCardTimeout);

        try {
          bridge.app.productDiscount({
            item_price_selector: bridge.jquery(price),
            template: 'collection',
            product_id: cardData.product.id,
            product_handle: cardData.product.handle,
            variant_id: cardData.variant.id,
            variant_sku: cardData.variant.sku || '',
            variant_price: cardData.variant.price,
            variant_compare_at_price: cardData.variant.compare_at_price || 0,
            output: true,
            remove_duplicate_table: true
          }, callback);
          callReturned = true;

          if (callbackCalled) {
            handleResponse(callbackResponse);
          }
        } catch (error) {
          finish(false, true, error);
        }
      }.bind(this));
    }

    createCartForm(cardData) {
      var form = createElement('form', 'swym-wishlist-card__form');
      var variantId = createElement('input');
      var quantity = createElement('input');
      var button = createElement('button', 'btn btn--full add-to-cart swym-wishlist-card__add');
      var buttonLabel = cardData.available
        ? this.config.strings.addToCart
        : cardData.resolved ? this.config.strings.soldOut : this.config.strings.unavailable;

      form.method = 'post';
      form.action = this.config.routes.cartAddForm;
      form.enctype = 'multipart/form-data';

      variantId.type = 'hidden';
      variantId.name = 'id';
      variantId.value = normalizeId(cardData.swym.epi);
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';

      button.type = 'submit';
      button.dataset.disabled = String(!cardData.available);
      button.disabled = !cardData.available;
      button.appendChild(createElement('span', '', buttonLabel));

      form.appendChild(variantId);
      form.appendChild(quantity);
      form.appendChild(button);
      return form;
    }

    createProductDetailsCta(cardData) {
      var container = createElement('div', 'swym-wishlist-card__form');
      var link = createElement(
        'a',
        'btn btn--secondary btn--full swym-wishlist-card__details',
        this.config.strings.viewDetails
      );

      link.href = cardData.url;
      link.dataset.swymWishlistDetails = '';
      container.appendChild(link);
      return container;
    }

    initializeAjaxCart(form, card, cardData, index) {
      if (!window.theme || typeof theme.AjaxProduct !== 'function') {
        return;
      }

      var eventId = 'swym-wishlist-' + this.root.dataset.sectionId + '-' + index;
      var successEvent = 'ajaxProduct:added:' + eventId;
      var errorEvent = 'ajaxProduct:error:' + eventId;
      var timeoutId = null;
      var onSubmit = function () {
        this.setCardBusy(card, true);
        this.setCartButtonsDisabled(true);
        timeoutId = window.setTimeout(function () {
          this.setCardBusy(card, false);
          this.setCartButtonsDisabled(false);
          this.announce(this.config.strings.addError);
        }.bind(this), 15000);
      }.bind(this);
      var onSuccess = function () {
        window.clearTimeout(timeoutId);
        this.setCardBusy(card, false);
        this.setCartButtonsDisabled(false);
        this.announce(replaceToken(this.config.strings.addSuccess, '[title]', cardData.title));
      }.bind(this);
      var onError = function (event) {
        window.clearTimeout(timeoutId);
        this.setCardBusy(card, false);
        this.setCartButtonsDisabled(false);
        this.announce(this.config.strings.addError);
        console.error('Swym wishlist: Unable to add the saved variant to cart.', event.detail);
      }.bind(this);

      form.addEventListener('submit', onSubmit);
      document.addEventListener(successEvent, onSuccess);
      document.addEventListener(errorEvent, onError);
      new theme.AjaxProduct(form, '.add-to-cart', { scopedEventId: eventId });

      this.cartEventCleanups.set(cardData.key, function () {
        window.clearTimeout(timeoutId);
        form.removeEventListener('submit', onSubmit);
        document.removeEventListener(successEvent, onSuccess);
        document.removeEventListener(errorEvent, onError);
      });
    }

    initializePageCart(form, card, cardData) {
      var button = form.querySelector('.add-to-cart');
      var onSubmit = function (event) {
        event.preventDefault();

        if (button.disabled) {
          return;
        }

        this.setCardBusy(card, true);
        button.classList.add('btn--loading');
        this.clearCartError(form);

        window.fetch(this.config.routes.cartAdd, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (data) {
            if (!response.ok || data.status === 422) {
              throw data;
            }
            return data;
          });
        }).then(function (product) {
          this.announce(replaceToken(this.config.strings.addSuccess, '[title]', cardData.title));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              addToCartBtn: button,
              product: product
            }
          }));
          window.location.assign(this.config.routes.cartPage);
        }.bind(this)).catch(function (error) {
          var message = error.description || error.message || this.config.strings.addError;
          this.showCartError(form, message);
          this.setCardBusy(card, false);
          this.announce(this.config.strings.addError);
          console.error('Swym wishlist: Unable to add the saved variant to cart.', error);
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: message
            }
          }));
        }.bind(this));
      }.bind(this);

      form.addEventListener('submit', onSubmit);
      this.cartEventCleanups.set(cardData.key, function () {
        form.removeEventListener('submit', onSubmit);
      });
    }

    clearCartError(form) {
      var error = form.querySelector('.errors');
      if (error) {
        error.remove();
      }
    }

    showCartError(form, message) {
      this.clearCartError(form);
      form.appendChild(createElement('div', 'errors text-center', message));
    }

    handleClick(event) {
      var detailsLink = event.target.closest('[data-swym-wishlist-details]');
      var removeButton = event.target.closest('[data-swym-wishlist-remove]');

      if (
        detailsLink &&
        this.root.contains(detailsLink) &&
        detailsLink.getAttribute('aria-disabled') === 'true'
      ) {
        event.preventDefault();
        return;
      }

      if (!removeButton || !this.root.contains(removeButton) || removeButton.disabled) {
        return;
      }

      event.preventDefault();
      this.removeItem(removeButton.dataset.swymWishlistRemove);
    }

    removeItem(key) {
      var cardData = this.items.get(key);
      var card = cardData && cardData.card;

      if (!cardData || !card || this.pendingRemovals.has(key)) {
        return;
      }

      var operation = {
        card: card,
        product: copySwymProduct(cardData.swym)
      };
      this.pendingRemovals.set(key, operation);
      this.setCardBusy(card, true);

      try {
        this.swat.removeFromWishList(
          operation.product,
          function () {
            if (this.pendingRemovals.get(key) !== operation) {
              return;
            }

            this.pendingRemovals.delete(key);
            this.items.delete(key);
            this.cleanupCartEventListener(key);
            operation.card.closest('.grid__item').remove();
            this.announce(replaceToken(this.config.strings.removeSuccess, '[title]', cardData.title));
            document.dispatchEvent(new CustomEvent('swym:wishlist:changed'));

            if (this.items.size) {
              this.updateCount();
            } else {
              this.showState('empty');
            }
          }.bind(this),
          function (error) {
            if (this.pendingRemovals.get(key) !== operation) {
              return;
            }

            this.pendingRemovals.delete(key);
            this.setCardBusy(card, false);
            this.announce(this.config.strings.removeError);
            console.error('Swym wishlist: Unable to remove the saved variant.', error);
          }.bind(this)
        );
      } catch (error) {
        this.pendingRemovals.delete(key);
        this.setCardBusy(card, false);
        this.announce(this.config.strings.removeError);
        console.error('Swym wishlist: Unable to remove the saved variant.', error);
      }
    }

    setCardBusy(card, isBusy) {
      card.setAttribute('aria-busy', String(isBusy));
      card.classList.toggle('is-busy', isBusy);
      card.querySelectorAll('button').forEach(function (button) {
        button.disabled = isBusy || button.dataset.disabled === 'true';
        if (!isBusy && button.classList.contains('add-to-cart')) {
          button.classList.remove('btn--loading');
        }
      });

      var detailsLink = card.querySelector('[data-swym-wishlist-details]');
      if (detailsLink) {
        if (isBusy) {
          detailsLink.setAttribute('aria-disabled', 'true');
          detailsLink.setAttribute('tabindex', '-1');
        } else {
          detailsLink.removeAttribute('aria-disabled');
          detailsLink.removeAttribute('tabindex');
        }
      }
    }

    setCartButtonsDisabled(isDisabled) {
      this.root.querySelectorAll('.swym-wishlist-card__add').forEach(function (button) {
        var card = button.closest('[data-swym-wishlist-card]');
        var cardIsBusy = card && card.classList.contains('is-busy');
        button.disabled = isDisabled || cardIsBusy || button.dataset.disabled === 'true';
      });
    }

    updateCount() {
      var count = this.items.size;
      var template = count === 1 ? this.config.strings.countOne : this.config.strings.countOther;
      this.count.textContent = replaceToken(template, '[count]', count);
    }

    announce(message) {
      this.status.textContent = '';
      window.setTimeout(function () {
        if (this.status) {
          this.status.textContent = message;
        }
      }.bind(this), 0);
    }

    cleanupCartEventListener(key) {
      var cleanup = this.cartEventCleanups.get(key);
      if (cleanup) {
        cleanup();
        this.cartEventCleanups.delete(key);
      }
    }

    clearCartEventListeners() {
      this.cartEventCleanups.forEach(function (cleanup) {
        cleanup();
      });
      this.cartEventCleanups.clear();
    }
  }

  function mountWishlistPages(scope) {
    if (!swatInstance) {
      return;
    }

    var roots = [];
    if (scope.matches && scope.matches('[data-swym-wishlist-page]')) {
      roots.push(scope);
    }
    scope.querySelectorAll('[data-swym-wishlist-page]').forEach(function (root) {
      roots.push(root);
    });

    roots.forEach(function (root) {
      if (controllers.has(root)) {
        return;
      }

      try {
        controllers.set(root, new SwymWishlistPage(root, swatInstance));
      } catch (error) {
        console.error('Swym wishlist: Unable to initialize the wishlist page.', error);
        var loading = root.querySelector('[data-swym-wishlist-loading]');
        var errorState = root.querySelector('[data-swym-wishlist-error]');
        if (loading) {
          loading.hidden = true;
        }
        if (errorState) {
          errorState.hidden = false;
        }
      }
    });
  }

  function onSwymLoadCallback(swat) {
    swatInstance = swat;
    mountWishlistPages(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountWishlistPages(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-swym-wishlist-page]').forEach(function (root) {
      var controller = controllers.get(root);
      if (controller) {
        controller.destroy();
        controllers.delete(root);
      }
    });
  });

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
})();
